import type { CustomTimeGroupsConfig } from "../../downloads/dailyPrintout/types";
import type { PrintoutColumnType } from "./Header/usePrintout";

export interface PrintoutCustomizationState {
	columnGroupingBy: PrintoutColumnType[] | null;
	customTimeGroups: CustomTimeGroupsConfig;
}

export const setCustomTimeGroupsEnabled = <T extends PrintoutCustomizationState>(state: T, enabled: boolean): T => ({
	...state,
	columnGroupingBy: enabled ? ["shiftTime"] : state.columnGroupingBy,
	customTimeGroups: { ...state.customTimeGroups, enabled },
});

export const setColumnGrouping = <T extends PrintoutCustomizationState>(state: T, columnGroupingBy: readonly PrintoutColumnType[] | null): T => {
	const remainsShiftTime = columnGroupingBy?.[0] === "shiftTime";
	return {
		...state,
		columnGroupingBy: columnGroupingBy ? [...columnGroupingBy] : columnGroupingBy,
		customTimeGroups: remainsShiftTime ? state.customTimeGroups : { ...state.customTimeGroups, enabled: false },
	};
};
